import { Component, Vue } from 'vue-property-decorator';

/**
 * Provides helpers to access athlete profile
 */
@Component
export class AthleteProfileMixin extends Vue {
	
}
